import { combineReducers } from 'redux'
import { RECEIVE_ORDERS, RECEIVE_ORDER, RECEIVE_ORDER_LICENSES } from '../actions/order-actions'

const searchResults = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_ORDERS:
      return action.orders
    default: return state
  }
}

const detail = ( state = { customer: {}, items: [] }, action) => {
  switch(action.type) {
    case RECEIVE_ORDER:
      return action.order
    default:
      return state
  }
}

const licenses = ( state = [], action ) => {
  switch(action.type) {
    case RECEIVE_ORDER_LICENSES:
      return action.licenses
    default:
      return state
  } 
}

export default combineReducers({
  searchResults, detail, licenses
})
